import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import styled from 'styled-components';

export const StyledAvatar = styled(Avatar)`
    background-color: #00aa8d;
`;

export const StyledList = styled(List)`
    display: flex;
`;

export const StyledListItem = styled(ListItem)`
    padding: 4px 8px;
`;
